import { TranslateService } from "@ngx-translate/core";
import { DialogRef, DialogService } from "@ngneat/dialog";
import { InstanceType } from "src/app/shared/types/instance-types";
import { InstanceService } from "src/app/shared/services/instance.service";
import { Component, inject, Input, TemplateRef, ViewChild } from "@angular/core";

@Component({
  selector: "app-instance",
  templateUrl: "./instance.component.html",
  standalone: false,
})
export class InstanceComponent {
  @Input() instanceId!: number | null;
  @Input() contractId!: number;

  @ViewChild("approveModalTemplate") approveModalTemplate!: TemplateRef<unknown>;

  approveModal!: DialogRef;
  private dialog = inject(DialogService);

  instance!: InstanceType;

  constructor(public translate: TranslateService, private instanceService: InstanceService) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    if (!this.instanceId) {
      return;
    }
    const loadSubscription = this.instanceService.getInstance(this.instanceId).subscribe({
      next: (res) => {
        loadSubscription.unsubscribe();
        this.instance = res;
      },
      error: () => {
        loadSubscription.unsubscribe();
      },
    });
  }

  approve() {
    this.approveModal = this.dialog.open(this.approveModalTemplate, {
      id: `dialog-${crypto.randomUUID()}`,
    });
  }

  submitedApproveForm() {
    this.approveModal.close();
    this.loadData();
  }
}
